import { atom } from 'jotai'

export const incommingChatMessageAtom = atom<{
  timestamp: number
  userId: string
  id: string
  avatar: string | null
  name: string
  text: string
} | null>(null)
